import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { translations, supportedLanguages } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = window.localStorage.getItem('unnie_lang');
      if (saved && supportedLanguages.includes(saved)) return saved;
    }
    return 'de';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('unnie_lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.de,
      supportedLanguages,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return ctx;
};
